import MaterialCombobox from 'components/onboarding/material-combobox'
import SampleToolLibrary from 'components/onboarding/sample-tool-library'
import ToolLibraryDropzone from 'components/onboarding/tool-library-dropzone'
import UploadedToolLibrary from 'components/onboarding/uploaded-tool-library'
import Wrapper from 'components/onboarding/wrapper'
import { Toggle } from 'components/ui'
import { useOnboarding } from 'context/onboarding-context'

const ChooseToolLibrary = () => {
  const { step, toolLibrary, unit, setUnit, material, setMaterial } =
    useOnboarding()
  const disabled = Boolean(toolLibrary)

  return (
    <Wrapper isVisible={step === 0}>
      <div className="mb-6 flex w-full flex-row md:-mt-20 md:mb-14 md:flex-row-reverse">
        <Toggle
          options={['INCH', 'MM']}
          isRight={unit === 'mm'}
          setIsRight={(isRight) => setUnit(isRight ? 'mm' : 'in')}
          className="mr-0.5 mt-0.5"
          optionClass="w-12"
          toggleClass="w-12"
          switchClass="w-24 bg-gray-100 outline-gray-100"
          readonly={disabled}
        />
      </div>
      <section className="flex flex-col gap-4">
        <label className="flex flex-row flex-wrap items-center gap-1 text-4xl text-gray-300">
          Choose a tool library to use for
          <MaterialCombobox
            selected={material}
            setSelected={setMaterial}
            disabled={disabled}
          />
        </label>
        {!toolLibrary && (
          <div className="flex flex-col items-center gap-4 lg:flex-row">
            <ToolLibraryDropzone />
            <SampleToolLibrary />
          </div>
        )}
        {toolLibrary && <UploadedToolLibrary />}
      </section>
    </Wrapper>
  )
}

export default ChooseToolLibrary
